import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  constructor() { }
  private _loaderState = new BehaviorSubject<boolean>(false);
  loaderState = this._loaderState.asObservable();

  show(): void {
    this._loaderState.next(true);
  }

  hide(): void {
    this._loaderState.next(false);
  }
}
